import { CdkDrag, CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit } from '@angular/core';
// import * as _ from 'lodash';
import { ObjectState } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import moment from 'moment';
import { iif, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { appConstants } from '../../../../../_shared/constants/app-constants.const';
import { AppModulesType } from '../../../../../_shared/enums/appModulesType.enum';
import { CusomerCreatedFromType } from '../../../../../_shared/enums/customer/cusomerCreatedFromType.enum';
import { ReservationStatusType } from '../../../../../_shared/enums/reservationStatusType.enum';
import { GuiUserContractorSettings, Subcontractor } from '../../../../../_shared/model';
import { HelperService } from '../../../../../_shared/services';
import { ActiveModulesService } from '../../../../../_shared/services/activeModules.service';
import { SimilarCustomersService } from '../../../../../_shared/services/similar-customers.service';
import {
    LoadPendingReservations,
    LoadTodaysReservations,
    SetReservationKanbanStatus,
    SetReservationVisitId,
    UpdateReservation,
} from '../../../../../_shared/state/kanban/kanban.actions';
import { KanbanState } from '../../../../../_shared/state/kanban/kanban.state';
import { TermsService } from '../../_services';
import { tags } from './../../../../../_shared/constants/customTags.const';
import { ReservationType } from './../../../../../_shared/enums/schedule/reservationType.enum';
import { Event } from './../../../../../_shared/model/event.model';
import { Reservation } from './../../../../../_shared/model/reservation.model';
import { EventNew } from './../../../../../_shared/model/schedule/eventNew.model';
import { EventUpdate } from './../../../../../_shared/model/schedule/eventUpdate.model';
import { MfToastService } from './../../../../../_shared/services/mfToast.service';
import { GetAndLoadSubcontractors, SetCalendarSubcontractors } from './../../../../../_shared/state/base/base.actions';
import { BaseState } from './../../../../../_shared/state/base/base.state';
import { ReservationService } from './../../_services/reservation.service';
import { VisitService } from './../../_services/visit.service';
import { KanbanStatus } from './enum/kanban-status.enum';
import { KbColumns } from './model/kb-columns.model';
import { KbItem } from './model/kb-item.model';
@Component({
    selector: 'index-kanban',
    templateUrl: './index-kanban.component.html',
    styleUrls: ['./index-kanba.component.scss'],
})
export class IndexKanbanComponent implements OnInit, OnDestroy {
    private onDestroy$ = new Subject<void>();

    private contractorId: number = this.store.selectSnapshot(BaseState.activeContractorId);
    allSubcontractors$ = this.store.select(BaseState.getAllSubcontractors());
    selectedSubconstractors$ = this.store.select(BaseState.GetUserSettings).pipe(
        takeUntil(this.onDestroy$),
        map((settings: GuiUserContractorSettings) => settings?.calendar?.subconstractors),
    );
    todaysReservations$ = this.store.select(KanbanState.todaysReservations$);
    pendingReservations$ = this.store.select(KanbanState.pendingReservations$);

    columns: KbColumns = new KbColumns().deserialize({
        col1: [],
        col2: [],
        col3: [],
        col4: [],
    });
    highlightColumns: { [key: string]: boolean } = {
        col1: false,
        col2: false,
        col3: false,
        col4: false,
    };
    isDragging = false;
    isMdpsModuleActive = this.am.isAM(AppModulesType.OCCUPATIONAL_MEDICINE);

    constructor(
        private rest: ReservationService,
        private store: Store,
        private toast: MfToastService,
        private visitRest: VisitService,
        private helper: HelperService,
        private termRest: TermsService,
        private am: ActiveModulesService,
        private similarCustomersService: SimilarCustomersService,
    ) {}

    ngOnInit() {
        this.initSubscontractorsListener();
        this.initReservationsListener();
        this.store.dispatch(new GetAndLoadSubcontractors());
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    private initSubscontractorsListener(): void {
        this.selectedSubconstractors$.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.store.dispatch(new LoadTodaysReservations());
            this.store.dispatch(new LoadPendingReservations());
        });
    }

    private initReservationsListener(): void {
        this.todaysReservations$
            .pipe(
                takeUntil(this.onDestroy$),
                filter(res => res?.state === ObjectState.VALID),
                map(res => res.value),
            )
            .subscribe((res: Reservation[]) => {
                this.handleReservationsLoaded(res);
            });
    }

    private handleReservationsLoaded(reservations: Reservation[]): void {
        this.resetColumns();
        reservations.map((reservation: Reservation) => {
            if (reservation?.visitEndDate || reservation?.noShow || reservation.kanbanStatus == KanbanStatus.CONCLUDE) {
                this.columns.col4.push(
                    new KbItem().deserialize({
                        status: 'col1',
                        data: reservation,
                    }),
                );
            } else if (reservation.visitId) {
                this.columns.col3.push(
                    new KbItem().deserialize({
                        status: 'col1',
                        data: reservation,
                    }),
                );
            } else if (reservation.kanbanStatus == KanbanStatus.ADMITTED) {
                this.columns.col2.push(
                    new KbItem().deserialize({
                        status: 'col1',
                        data: reservation,
                    }),
                );
            } else {
                this.columns.col1.push(
                    new KbItem().deserialize({
                        status: 'col1',
                        data: reservation,
                    }),
                );
            }
        });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private updateReservation(prereservationId: string, item: EventUpdate, event: CdkDragDrop<any>): Observable<any> {
        return this.store.dispatch(new UpdateReservation(prereservationId, item)).pipe(
            catchError(err => {
                this.toast.error('Napaka pri spremembi statusa rezervacije');
                //vrnemo na prejsnje mesto
                // return to previous column
                transferArrayItem(event.container.data, event.previousContainer.data, event.currentIndex, event.previousIndex);
                return throwError(() => err);
            }),
        );
    }

    reloadEventsPublic(data: Subcontractor[]) {
        this.store.dispatch(new SetCalendarSubcontractors(data));
    }

    isPriority(reservationFrom: string): boolean {
        const reservationDate = moment(reservationFrom);
        const currentDate = moment();
        return currentDate.diff(reservationDate, 'days') > appConstants.kanbanPriorityItemAge;
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    drop(item: CdkDragDrop<any>): void {
        if (item.previousContainer === item.container) {
            moveItemInArray(item.container.data, item.previousIndex, item.currentIndex);
        } else {
            const reservation: Reservation = <Reservation>item?.item?.data?.data;
            this.handleColAll(item, reservation);
        }

        //SORTIRANJE PRVEGA STOLPCA
        if (item?.container?.id == 'col1') {
            this.columns.col1.sort((a: KbItem, b: KbItem) => {
                let result = -1;
                if (a && b) {
                    // if (moment(a.data.reservationFrom) > moment(b.data.reservationFrom)) {

                    if (a.data.reservationFrom > b.data.reservationFrom) {
                        result = 1;
                    }
                }

                return result;
            });
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private handleColAll(item: CdkDragDrop<any>, reservation: Reservation): void {
        switch (item?.container?.id) {
            case 'col1':
                //rezervaciji spremenimo status v WAITING
                this.updateReservation(
                    reservation.prereservationId,
                    new EventUpdate().deserialize({ kanbanStatus: KanbanStatus.WAITING }),
                    item,
                ).subscribe(() => {
                    item.item.data.status = item?.container?.id;
                    transferArrayItem(item.previousContainer.data, item.container.data, item.previousIndex, item.currentIndex);
                });
                break;
            case 'col2':
                //rezervaciji spremenimo status v ADMITTED
                transferArrayItem(item.previousContainer.data, item.container.data, item.previousIndex, item.currentIndex);
                this.updateReservation(
                    reservation.prereservationId,
                    new EventUpdate().deserialize({ kanbanStatus: KanbanStatus.ADMITTED }),
                    item,
                ).subscribe(() => {
                    item.item.data.status = item?.container?.id;
                });
                break;

            case 'col3':
                of(item?.item?.data?.data as Event)
                    .pipe(
                        switchMap(event => {
                            return iif(
                                () => event.customer?.createdFrom == CusomerCreatedFromType.PATIENT_APP,
                                this.similarCustomersService.findSimilarCustomers(this.contractorId, event, false).pipe(
                                    tap(result => {
                                        if (!result) {
                                            throw new Error('');
                                        }
                                    }),
                                ),
                                of(null),
                            );
                        }),
                        switchMap(() =>
                            iif(
                                () => reservation.status == ReservationStatusType.RECURRING_EVENT,
                                this.rest.sendPreResevation(this.getRecurringReservation(reservation)).pipe(
                                    switchMap(event =>
                                        this.rest.sendResevation(event).pipe(
                                            switchMap(() => {
                                                return this.visitRest.createVisitFromPrereservation(
                                                    event.prereservationId,
                                                    reservation?.customer?.id,
                                                );
                                            }),
                                        ),
                                    ),
                                    takeUntil(this.onDestroy$),
                                ),
                                this.visitRest
                                    .createVisitFromPrereservation(reservation.prereservationId, reservation.customer.id)
                                    .pipe(takeUntil(this.onDestroy$)),
                            ),
                        ),
                        catchError(err => {
                            this.toast.error('Napaka pri ustavarjanju obravnave.');
                            throw new Error(err);
                        }),
                    )
                    .subscribe(visitId => {
                        item.item.data.status = item?.container?.id;
                        this.store.dispatch([
                            new SetReservationVisitId(reservation.prereservationId, visitId),
                            new SetReservationKanbanStatus(reservation.prereservationId, KanbanStatus.VISIT),
                        ]);
                        transferArrayItem(item.previousContainer.data, item.container.data, item.previousIndex, item.currentIndex);
                    });
                break;

            case 'col4':
                this.handleCol4(item, reservation);
                break;
            default:
                break;
        }
    }

    private getRecurringReservation(reservation: Reservation): EventNew {
        return new EventNew().deserialize({
            forceUpdate: true,
            contractor: reservation.contractor,
            service: reservation.service,
            recurringId: reservation.recurringId,
            isRecurring: true,
            customer: reservation.customer,
            customTagId: 1,
            recurringType: tags.RECURRING_NEW.obj.SINGLE.sid,
            reservationType: ReservationType.EA,
            asset: reservation.asset,
            telemed: false,
            from: reservation.reservationFrom,
            to: reservation.reservationTo,
            recurring: tags.RECURRING_NEW.obj.SINGLE.sid,
        });
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private handleCol4(item: CdkDragDrop<any>, reservation: Reservation): void {
        if (!reservation.visitId) {
            //razervacija nima ustvarjene obravnave vprasamo ce je noshow
            this.helper.displayAlert('Neizvedena obravnava', 'Termin bo odpovedan, nadaljujem?').then(result => {
                if (result?.isConfirmed) {
                    this.termRest
                        .customerNoShow(reservation.prereservationId, true)
                        .pipe(
                            catchError(err => {
                                this.toast.error('Napaka pri spremembi statusa rezervacije');
                                transferArrayItem(item.container.data, item.previousContainer.data, item.currentIndex, item.previousIndex);
                                return throwError(() => err);
                            }),
                            switchMap(() => this.store.dispatch(new SetReservationKanbanStatus(reservation.prereservationId, KanbanStatus.CONCLUDE))),
                        )
                        .subscribe(() => {
                            item.item.data.status = item?.container?.id;
                            transferArrayItem(item.previousContainer.data, item.container.data, item.previousIndex, item.currentIndex);
                        });
                } else {
                    transferArrayItem(item.container.data, item.previousContainer.data, item.currentIndex, item.previousIndex);
                }
            });
        } else {
            this.visitRest
                .concludeVisit(this.contractorId, reservation.visitId)
                .pipe(
                    catchError(err => {
                        this.toast.error('Napaka pri zaključevanju obravnave.');
                        return throwError(() => err);
                    }),
                    switchMap(() => this.store.dispatch(new SetReservationKanbanStatus(reservation.prereservationId, KanbanStatus.CONCLUDE))),
                )
                .subscribe(() => {
                    item.item.data.status = item?.container?.id;
                    transferArrayItem(item.previousContainer.data, item.container.data, item.previousIndex, item.currentIndex);
                });
        }
    }

    onDrag(drag: CdkDrag): void {
        this.clearHighlihtedColumns();
        (<string[]>drag?.dropContainer?.connectedTo).map((el: string) => {
            this.highlightColumns[el] = true;
        });
        this.isDragging = true;
    }
    endDrag(): void {
        this.clearHighlihtedColumns();
    }

    private clearHighlihtedColumns(): void {
        this.highlightColumns.col1 = this.highlightColumns.col2 = this.highlightColumns.col3 = this.highlightColumns.col4 = false;
    }

    private resetColumns(): void {
        this.columns.col1 = [];
        this.columns.col2 = [];
        this.columns.col3 = [];
        this.columns.col4 = [];
    }
}
